// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__HTkk-","topBottomGutter":"Layout_topBottomGutter__1rGmZ"};